// Configuration de l'API selon l'environnement
// Utiliser directement la fonction Netlify car les redirects ne fonctionnent pas
export const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/.netlify/functions/hospitable-proxy'
  : process.env.REACT_APP_API_URL || '/api';